import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { setTouchEditor } from "../../../../actions/index";

import useTracksToPlaylist from '../../../../hooks/useTracksToPlaylist';

const usePlaylistEdit = () => {
  const dispatch = useDispatch();
  const storeList = useSelector( state => state.storeList );
  const selectedItems = useSelector(state => state.selectedItems);
  const hasSelectedItems = selectedItems.length > 0;
  
  const { addToPlaylist } = useTracksToPlaylist(selectedItems);
  const removeSelected = () => {
    window.dispatchEvent(new KeyboardEvent('keydown', {key: 'Backspace'}));
    setTimeout(() => { window.dispatchEvent(new KeyboardEvent('keyup', {key: 'Backspace'})); }, 500)
  }

  useEffect(() => {
    return () => { dispatch(setTouchEditor(false)); }
  },[dispatch])

  const moveDirection = (top) => () => {
    if (selectedItems.length > 0 && storeList && storeList.moveSortable) { storeList.moveSortable(top) }
  }

  const storeX = {
    removeSelected,
    addToPlaylist,
    hasSelectedItems,
    moveDirection
  };

  return storeX;
};

export default usePlaylistEdit;
